import script from "./BookingStep5.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingStep5.vue?vue&type=script&setup=true&lang=js"

import "./BookingStep5.vue?vue&type=style&index=0&id=e7c0bf3a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7c0bf3a"]])

export default __exports__